// @flow
import path from 'ramda/es/path';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';
import { toCamelCase } from 'app/common/lib/object';


export const SHOP_CART_REQUEST = 'SHOP_CART_REQUEST';
export const SHOP_CART_SUCCESS = 'SHOP_CART_SUCCESS';
export const SHOP_CART_FAILURE = 'SHOP_CART_FAILURE';


/**
 * Запрос данных корзины / создание корзины (при отсутствии id)
 */
export const cartFetchOrCreate = (id: ?string) => async (dispatch: Function) => {
  const params = id ? { cart_id: id } : {};
  dispatch(action(SHOP_CART_REQUEST, { cartId: id, params }));
  try {
    const res = await shopApiRequest('cart', 'get', { params });
    const data = toCamelCase(path(['data', 'data'], res));
    dispatch(action(SHOP_CART_SUCCESS, data));
    return data;
  } catch (error) {
    dispatch(action(SHOP_CART_FAILURE, {
      err: (id
        ? 'Запрос содержимого корзины не удался'
        : 'Запрос на создание корзины не удался'),
      data: { cartId: id, params },
      error,
    }));
    return null;
  }
};
